import React, { useState } from 'react';
import ArtistCard from '../components/artists/ArtistCard';

const Comparisons: React.FC = () => {
  // Filter State
  const [selectedGenre, setSelectedGenre] = useState<string>('all');
  const [selectedCategory, setSelectedCategory] = useState<string>('similar');

  // Mock data for the artist list
  const artists = [
    { id: 1, name: 'DJ Synthwave', genre: 'Electronic', score: 72, category: 'similar', avatar: '' },
    { id: 2, name: 'Indie Collective', genre: 'Indie Rock', score: 67, category: 'similar', avatar: '' },
    { id: 3, name: 'Lofi Producer', genre: 'Hip Hop', score: 65, category: 'similar', avatar: '' },
    { id: 4, name: 'Neo Jazz Trio', genre: 'Jazz', score: 70, category: 'similar', avatar: '' },
    { id: 5, name: 'Electronic Dreams', genre: 'Electronic', score: 58, category: 'newcomer', avatar: '' },
    { id: 6, name: 'Post Rock Band', genre: 'Rock', score: 63, category: 'similar', avatar: '' },
    { id: 7, name: 'Future Soul', genre: 'Soul', score: 61, category: 'newcomer', avatar: '' },
    { id: 8, name: 'Ambient Explorer', genre: 'Electronic', score: 55, category: 'newcomer', avatar: '' },
    { id: 9, name: 'Pop Sensation', genre: 'Pop', score: 85, category: 'established', avatar: '' },
    { id: 10, name: 'Rock Legends', genre: 'Rock', score: 92, category: 'established', avatar: '' },
    { id: 11, name: 'New Wave', genre: 'Rock', score: 59, category: 'newcomer', avatar: '' },
    { id: 12, name: 'Bedroom Producer', genre: 'Electronic', score: 51, category: 'newcomer', avatar: '' },
  ];

  // Filter artists based on selected filters
  const filteredArtists = artists.filter(artist => {
    const genreMatch = selectedGenre === 'all' || artist.genre === selectedGenre;
    const categoryMatch = selectedCategory === 'all' || artist.category === selectedCategory;
    return genreMatch && categoryMatch;
  });

  // Extract unique genres for the filter dropdown
  const uniqueGenres = Array.from(new Set(artists.map(artist => artist.genre)));

  return (
    <div className="container mx-auto">
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-gray-800">Artist Comparison</h1>
        <p className="text-gray-600">Compare your performance with other artists in similar categories.</p>
      </div>

      {/* Filter section */}
      <div className="bg-white rounded-lg shadow p-4 mb-6">
        <div className="flex flex-col md:flex-row space-y-3 md:space-y-0 md:space-x-4">
          <div>
            <label htmlFor="category-filter" className="block text-sm font-medium text-gray-700 mb-1">
              Category
            </label>
            <select
              id="category-filter"
              value={selectedCategory}
              onChange={(e) => setSelectedCategory(e.target.value)}
              className="block w-full pl-3 pr-10 py-2 text-base border border-gray-300 focus:outline-none focus:ring-green-500 focus:border-green-500 sm:text-sm rounded-md"
            >
              <option value="all">All Categories</option>
              <option value="newcomer">Newcomer (0-1k Followers)</option>
              <option value="similar">Similar Size (1k-10k Followers)</option>
              <option value="established">Established (10k+ Followers)</option>
            </select>
          </div>
          
          <div>
            <label htmlFor="genre-filter" className="block text-sm font-medium text-gray-700 mb-1">
              Genre
            </label>
            <select
              id="genre-filter"
              value={selectedGenre}
              onChange={(e) => setSelectedGenre(e.target.value)}
              className="block w-full pl-3 pr-10 py-2 text-base border border-gray-300 focus:outline-none focus:ring-green-500 focus:border-green-500 sm:text-sm rounded-md"
            >
              <option value="all">All Genres</option>
              {uniqueGenres.map((genre) => (
                <option key={genre} value={genre}>
                  {genre}
                </option>
              ))}
            </select>
          </div>

          <div className="flex items-end">
            <button 
              className="bg-green-600 hover:bg-green-700 text-white font-medium py-2 px-4 rounded-md"
              onClick={() => {
                setSelectedGenre('all');
                setSelectedCategory('all');
              }}
            >
              Reset Filters
            </button>
          </div>
        </div>
      </div>

      {/* Artist list */}
      <div className="bg-white rounded-lg shadow p-6">
        <h2 className="text-lg font-semibold text-gray-700 mb-4">
          {filteredArtists.length} Artists found
        </h2>
        
        {filteredArtists.length > 0 ? (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            {filteredArtists.map(artist => (
              <ArtistCard key={artist.id} artist={artist} />
            ))}
          </div>
        ) : (
          <div className="text-center py-12">
            <p className="text-gray-500">No artists found matching your filter criteria.</p>
            <button
              className="mt-2 text-green-600 hover:text-green-700 font-medium"
              onClick={() => {
                setSelectedGenre('all');
                setSelectedCategory('all');
              }}
            >
              Reset Filters
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default Comparisons;